import * as React from 'react';
import { connect } from 'react-redux';
import { Redirect } from 'react-router';
import { IApplicationState } from '../../store/IApplicationState';
import { validatePermission } from './validate-permission';
import { Permissions } from '../../models/enums/permissions';
import { ServiceCenter } from '../../models/utilities/service-center';
import { Routes } from '../../utils/app-constants';

// #region Component Props

interface IProps {
    currentPermissions      : Permissions[];
    requiredPermissions     : Permissions[];
    selectedServiceCenter   : ServiceCenter;
    requiredServiceCenters? : string[];
}

// #endregion

export class RequirePerrmissionBase extends React.Component<IProps> {

    public static defaultProps = {
        currentPermissions: [],
        selectedServiceCenter: undefined
    };

    public UNSAFE_componentWillReceiveProps(props: IProps) {
        this.ensureAuth();
    }

    public componentDidMount() {
        this.ensureAuth();
    }

    public render() {

        const validSC = this.ensureServiceCenter();
        const isAuthed = this.ensureAuth();

        if (isAuthed && validSC) {
            return <div>{this.props.children}</div>;
        }

        return <Redirect to={ Routes.UTILITY_FORBIDDEN } />

    }

    private ensureAuth = () => {
        const isAuthed = validatePermission({
            currentPermissions  : this.props.currentPermissions,
            requiredPermissions : this.props.requiredPermissions
        });

        return isAuthed;
    }

    private ensureServiceCenter = () => {

        if (this.props.requiredServiceCenters && this.props.requiredServiceCenters.length > 0) {

            if (this.props.requiredServiceCenters.indexOf(this.props.selectedServiceCenter.name) >= 0 ||
                this.props.selectedServiceCenter.name === 'ALL') {
                return true;
            }
            else {
                return false;
            }
        }

        return true;

    }
}

const mapStateToProps = (state: IApplicationState) => {
    return {
        currentPermissions: state.userdata.user.permissions && state.userdata.user.permissions.length > 0 ? state.userdata.user.permissions : [],
        selectedServiceCenter: state.userdata.activeServiceCenter
    };
};

const RequirePermissionConnected = connect(mapStateToProps, null)(RequirePerrmissionBase);

/**
 * Require a user have a given permission to use the component
 * @param ComponentToWrap Component to protect by permission
 * @param requirePermission The user must hold at least one of these. None means any user who is signed in.
 * @param requiredServiceCenters The service centers the component can be used in. None means any.
 */
export const RequirePermission = (ComponentToWrap: any, requirePermission: Permissions[], requiredServiceCenters?: string[]) => {
    return (props: any) => {
        return (
            <RequirePermissionConnected 
                {...props} 
                requiredPermissions={requirePermission}
                requiredServiceCenters={ requiredServiceCenters } >
                <ComponentToWrap {...props} />
            </RequirePermissionConnected>
        );
    };
};
